export const MOCK_DATA = {
  success: true,
  data: {
    id: 10,
    basic_information: {
      businessName: "GreenFarewell Preneed Advisors",
      provider_id: "PROV-2026-000010",
      businessDescription:
        "Eco-friendly preneed planning — offering green burial, water-cremation and terramation options to align with your values.",
      contactEmail: "alex.morgan@greenfarewell.com",
      contactPhone: "+17205152344",
      contactName: "Alex Morgan",
      contactPosition: "Advance Planning Advisor",
      operationalHours: null,
    },
    location_media_details: {
      business_address: {
        businessAddress: "102 W Chester St",
        street_line_2: "",
        city: "Lafayette",
        state: "Colorado",
        zipcode: "80026",
        country: "USA",
        latitude: 32.789,
        longitude: -96.8037,
      },
      serviceableLocations: [
        {
          id: 12,
          city: "Lafayette",
          state: "Colorado",
          zipcode: "80026",
          country: "USA",
          latitude: 32.789,
          longitude: -96.8037,
        },
      ],
      partnerMedia: [],
    },
    service_offerings: {
      serviceCategories: [
        "Preneed Products",
        "Funeral Arrangements",
        "Cemetery",
        "Transport",
        "Memorial Services",
      ],
      services: {
        "Preneed Products": [
          {
            serviceId: 7,
            serviceName: "Funeral Homes",
          },
          {
            serviceId: 9,
            serviceName: "Pre-Planning",
          },
          {
            serviceId: 13,
            serviceName: "Preneed Funeral Planning",
          },
        ],
        "Funeral Arrangements": [
          {
            serviceId: 7,
            serviceName: "Funeral Homes",
          },
          {
            serviceId: 8,
            serviceName: "Grief Support",
          },
          {
            serviceId: 2,
            serviceName: "Funeral Arrangements",
          },
          {
            serviceId: 13,
            serviceName: "Preneed Funeral Planning",
          },
          {
            serviceId: 14,
            serviceName: "Cremation Planning",
          },
        ],
        Cemetery: [
          {
            serviceId: 4,
            serviceName: "Cemetery",
          },
          {
            serviceId: 12,
            serviceName: "Direct Burial",
          },
          {
            serviceId: 14,
            serviceName: "Cremation Planning",
          },
        ],
        Transport: [
          {
            serviceId: 12,
            serviceName: "Direct Burial",
          },
          {
            serviceId: 9,
            serviceName: "Pre-Planning",
          },
        ],
        "Memorial Services": [
          {
            serviceId: 8,
            serviceName: "Grief Support",
          },
          {
            serviceId: 3,
            serviceName: "Memorial Services",
          },
          {
            serviceId: 9,
            serviceName: "Pre-Planning",
          },
          {
            serviceId: 14,
            serviceName: "Cremation Planning",
          },
        ],
      },
    },
    documents: {
      partnerLicenceDocuments: [],
      afpDocuments: [
        {
          mediaType: "document",
          mediaSubType: "afp_acknowledgment_form",
          url: "https://afp-memorial-qa-be.s3.us-east-1.amazonaws.com/uploads/AFP-Documents/afp_acknowledgment_forms/1769749943841-Refund%20Policy.docx?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAXEFUM7B4MZWG5P2Z%2F20260130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20260130T051300Z&X-Amz-Expires=3600&X-Amz-Signature=9f575cc6df281f2c9dccb248040b60ac18996ff3ee1cc6db862e15bc368f19c4&X-Amz-SignedHeaders=host&x-amz-checksum-mode=ENABLED&x-id=GetObject",
        },
        {
          mediaType: "document",
          mediaSubType: "afp_acknowledgment_form",
          url: "https://afp-memorial-qa-be.s3.us-east-1.amazonaws.com/uploads/AFP-Documents/afp_acknowledgment_forms/1769749943846-Service%20Provider%20Agreement.docx?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAXEFUM7B4MZWG5P2Z%2F20260130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20260130T051300Z&X-Amz-Expires=3600&X-Amz-Signature=19da6f364894eb162b0164c0a09874bafc63ffa48e7a147c8adc908083f29b77&X-Amz-SignedHeaders=host&x-amz-checksum-mode=ENABLED&x-id=GetObject",
        },
        {
          mediaType: "document",
          mediaSubType: "afp_acknowledgment_form",
          url: "https://afp-memorial-qa-be.s3.us-east-1.amazonaws.com/uploads/AFP-Documents/afp_acknowledgment_forms/1769749943849-Compliance%20standards%20and%20guidelines.docx?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAXEFUM7B4MZWG5P2Z%2F20260130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20260130T051300Z&X-Amz-Expires=3600&X-Amz-Signature=87d1ee5a4ccd920a7260e049acc43643cb4e2b8c39df77b0c2979fac1eef5507&X-Amz-SignedHeaders=host&x-amz-checksum-mode=ENABLED&x-id=GetObject",
        },
        {
          mediaType: "document",
          mediaSubType: "afp_acknowledgment_form",
          url: "https://afp-memorial-qa-be.s3.us-east-1.amazonaws.com/uploads/AFP-Documents/afp_acknowledgment_forms/1769749943847-Data%20Protection%20Policy.docx?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAXEFUM7B4MZWG5P2Z%2F20260130%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20260130T051300Z&X-Amz-Expires=3600&X-Amz-Signature=82b2942353ba9d15374822196028f0b83eded52035d17f60b92e2cdd6f379d12&X-Amz-SignedHeaders=host&x-amz-checksum-mode=ENABLED&x-id=GetObject",
        },
      ],
      partnerDocuments: [],
    },
    banking_information: {
      bankTaxProfileEIN: "234234324239",
      bankRoutingNumberABA: "2834928342",
      bankAccountType: "Savings",
      bankAccountNumber: "23420349234",
      bankAccountHolderName: "Vikas Sharma",
      w9Form: [],
    },
  },
};
